export enum WebhookEventType {
  Reservations = 'reservations',
  Properties = 'properties',
  Messaging = 'messages',
  Reviews = 'reviews',
}

export interface Webhook {
  id: string | null;
  url: string | null;
  name: string | null;
  types?: WebhookEventType[];
}

export interface WebhookResponse {
  webhook: null | Webhook;
  error?: string;
}

export enum WebhookType {
  Next = 'next',
  Legacy = 'legacy',
}
